import request from '@/service/index'

/**
 * 获取分享出来的课程资料详情
 * @param params
 * @returns
 */
export const getAICourse = (params: {skuId: string, hasWork: 1 | any}) => {
  return request({
    url: '/teach/v1/AICourse/item',
    method: 'GET',
    params
  })
}

/**
 * 获取分享出来的课程 类型是图文时的详情
 * @param params
 * @returns
 */
export const getAICoursePictureById = (id: string) => {
  return request({
    url: '/teach/v1/AICourse/item/' + id,
    method: 'GET'
  })
}
